export function validateEmail(email: string | null | undefined): boolean {
  if (!email) {
    return false
  }
  const re = /^(([^<>()[\]\\.,;:\s@éèàîï"]+(\.[^<>()[\]\\.,;:\s@éèàîï"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(email.toLowerCase())
}

export function validateHexaColor(hexaColor: string | null | undefined): boolean {
  if (!hexaColor) {
    return false
  }
  const re = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i
  return re.test(hexaColor.toLowerCase())
}

export function validatePhoneNumberE164(phoneNumber: string | null | undefined): boolean {
  if (!phoneNumber) {
    return false
  }
  const re = /^\+(?:[0-9] ?){6,14}[0-9]$/
  return re.test(phoneNumber)
}

export function validatePhoneNumberFrench(phoneNumber: string | null | undefined): boolean {
  if (!phoneNumber) {
    return false
  }
  const re = /^0[1-9]\d{8}$/
  return re.test(phoneNumber)
}

export function validatePhoneNumberFrenchOrE164(phoneNumber: string | null | undefined): boolean {
  if (!phoneNumber) {
    return false
  }
  return validatePhoneNumberFrench(phoneNumber) || validatePhoneNumberE164(phoneNumber)
}

export function validateAlphanumericSenderId(senderId: string | null | undefined): boolean {
  if (!senderId) {
    return false
  }
  const re = /^(?=.*[a-zA-Z])(?=.*[a-zA-Z0-9])([a-zA-Z0-9 ]{1,11})$/m
  return re.test(senderId)
}
